import React from 'react'
import { StyledCover, ContainerLogo, StyledLogo } from './styles'

const srcLogo = require('App/assets/images/ic_itm_logo.png')

const LoginCover = props => (
  <React.Fragment>
    <StyledCover src={props.coverSrc} alt={'cover'} />
    <ContainerLogo>
      <StyledLogo src={srcLogo} alt={'logo-itm'} />
    </ContainerLogo>
  </React.Fragment>
)

export default LoginCover
